import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "./apiClient";

const useSetGuard = () => {
  const { request, isLoading } = useApiClient();
  const [assinando, setAssinando] = useState(false);

  const callExternalHandler = useCallback(
    (safePayload) => {
      if (assinando) {
        console.warn("Assinatura já em andamento. Ignorando reenvio.");
        return;
      }

      setAssinando(true);

      try {
        if (typeof safePayload === "string") {
          const url = `setrnguard://${safePayload}`;
          window.location.href = url;
        } else if (Array.isArray(safePayload) && safePayload.length) {
          request(apiRoutes.usuarios.arquivo.selecionar, safePayload).finally(() => setAssinando(false));
        } else {
          console.warn("SafePayload inválido:", safePayload);
          setAssinando(false);
        }
      } catch {
        toast.warn("Verifique se você instalou o programa SET/RN Guard corretamente.");
        setAssinando(false);
      }
    },
    [assinando, request],
  );

  return {
    isLoading,
    assinar: (safePayload) => callExternalHandler(safePayload),
  };
};

export default useSetGuard;
